import { WorkflowReference } from 'types'
import { ReactComponent as Score10 } from 'assets/icons/workflows/informalFeedbackRequest/score10'
import { ReactComponent as Score20 } from 'assets/icons/workflows/informalFeedbackRequest/score20.svg'
import { ReactComponent as Score30 } from 'assets/icons/workflows/informalFeedbackRequest/score30.svg'
import { ReactComponent as DeclinedIcon } from 'assets/icons/workflows/informalFeedbackRequest/decline16.svg'
import { FunctionComponent, SVGProps } from 'react'
import Styles from './ReferenceMetadata.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  reference: WorkflowReference
}

const ValueIcon: { [key: string]: FunctionComponent<React.PropsWithChildren<SVGProps<SVGSVGElement>>> } = {
  '10': Score10,
  '20': Score20,
  '30': Score30,
  declined: DeclinedIcon,
}

const ValueComment: { [key: string]: string } = {
  '10': 'sent back',
  '20': 'left feedback',
  '30': 'approved',
  declined: 'skipped review',
}

export const ReferenceMetadata = ({ reference }: Props) => {
  const { isMobile } = useResponsiveDesign()
  const { metadata } = reference

  if (!metadata?.review?.score && !metadata?.review?.reason) return null

  const { score, reason } = metadata.review
  const value = score || reason

  const Icon = ValueIcon[value + '']

  return (
    <span className={Styles.text}>
      <Icon aria-hidden="true" className={Styles.icon} />
      {!isMobile && <span>{ValueComment[value + '']}</span>}
    </span>
  )
}
